// NoteModal.js
import React, { useState } from 'react';

const NoteModal = ({ onClose, onSubmit, currentNotes = [] }) => {
  const [newNote, setNewNote] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (newNote.trim()) {
      onSubmit(newNote);
      setNewNote('');
      onClose();
    }
  };

  return (
    <div className="tt-modal-backdrop">
      <div className="tt-modal">
        <div className="tt-modal-header">
          <h2 className="tt-modal-title">Add Note</h2>
          <button className="tt-modal-close" onClick={onClose}>×</button>
        </div>
        
        <div className="tt-modal-body">
          {currentNotes.length > 0 && (
            <div style={{ marginBottom: '18px', maxHeight: '200px', overflowY: 'auto' }}>
              <div className="tt-label">Previous Notes</div>
              {currentNotes.map((note, index) => (
                <div key={index} style={{ padding: '8px 0', borderBottom: '1px solid var(--tt-line)' }}>
                  {note}
                </div>
              ))}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <textarea
              className="tt-textarea"
              value={newNote}
              onChange={(e) => setNewNote(e.target.value)}
              placeholder="Enter your note here..."
              rows="4"
            />
            <div className="tt-modal-footer" style={{ margin: '18px -20px -18px' }}>
              <button type="button" onClick={onClose} className="tt-button tt-button--ghost">
                Cancel
              </button>
              <button type="submit" className="tt-button tt-button--primary">
                Add Note
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NoteModal;
